import React from 'react';
import { useSelector } from 'react-redux';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import { getCurrencyToggleDetails } from 'selectors/currencyToggleSelectors';
import { getDestinationCurrencyCode } from 'selectors/vehicleSelectSelectors';
import TaxesFeesModalContent from 'components/ReservationFlow/VehicleSelect/Modals/TaxesFeesModalContentContainer';

const storeKey = 'car_classes';

const TaxesFeesModal = () => {
  const currencyToggleDetails = useSelector((state) => getCurrencyToggleDetails(state, storeKey));
  const isPayTypeSelected = currencyToggleDetails?.isPayTypeSelected;
  const destinationCurrencyCode = useSelector((state) => getDestinationCurrencyCode(state));

  return (
    <Modal modalKey={MODAL.TAXES_FEES_MODAL} theme={MODAL_THEMES.WHITE}>
      <TaxesFeesModalContent destinationCurrencySelected={isPayTypeSelected === destinationCurrencyCode} />
    </Modal>
  );
};

export default TaxesFeesModal;
